import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../utils/Constants";


const getAuthHeader = () => {
    const token = localStorage.getItem("token");

    return {
        headers: {
            Authorization: token,
        },
    };
};

export const searchEmployees = createAsyncThunk(
    "employees/searchEmployees",
    async (searchText) => {
        if (!searchText) return [];

        const response = await axios.get(
            `${baseUrl}/employees?search=${searchText}`,
            getAuthHeader()
        );

        return response.data;
    }
);

const employeeSlice = createSlice({
    name: "employees",
    initialState: {
        employeeOptions: [],
        loading: false
    },

    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(searchEmployees.pending, (state) => {
                state.loading = true;
            })
            .addCase(searchEmployees.fulfilled, (state, action) => {
                state.loading = false;
                state.employeeOptions = action.payload;
            })
            .addCase(searchEmployees.rejected, (state) => {
                state.loading = false;
            });
    }
});

export default employeeSlice.reducer;